import * as React from 'react'

import type { BookkeepersManagementIncidenceQuery } from 'generated/resources/graphql'

export type IncidenceQueryData = NonNullable<
  BookkeepersManagementIncidenceQuery['bookkeepersManagement']
>['incidences'][number]

type IncidenceQueryContextValue = IncidenceQueryData[] | null | undefined
const incidenceQueryContext = React.createContext<IncidenceQueryContextValue>(null)

export const IncidencesProvider = incidenceQueryContext.Provider

export const useIncidences = (): IncidenceQueryContextValue => {
  const incidences = React.useContext(incidenceQueryContext)

  return incidences
}
